import { render, staticRenderFns } from "./index.vue?vue&type=template&id=41537b65&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=41537b65&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=41537b65&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41537b65",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41537b65')) {
      api.createRecord('41537b65', component.options)
    } else {
      api.reload('41537b65', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=41537b65&scoped=true", function () {
      api.rerender('41537b65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datav/index.vue"
export default component.exports